// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"54":"86fcbe81","142":"5561a437","707":"3250d99d","796":"3de57876"}[chunkId] + ".chunk.css";
};